module.exports = __webpack_public_path__ + "img/people-50-min.669b2724.png";